import React from 'react'
import { createComponentWithProxy } from 'react-fela'

const CLIENT_PUBLIC_PATH_FOR_ICONS = '/client'

const Icon = createComponentWithProxy(
	props => ({
		color: props.color ? props.color : 'inherit',
		fill: 'currentColor',
		width: 'inherit',
		height: 'inherit',
		extend: [
			{
				condition: props.shadow,
				style: {
					filter: 'drop-shadow(2px 1px 4px #000)',
				},
			},
			{
				condition: props.rotate180,
				style: {
					transform: 'rotate(180deg)',
				},
			},
		],
	}),
	'svg'
)

/** Dirty hack since svg-sprite webpack plugin does not work with isomor
 *  rendering. Be sure to sync the above path in case your icons aren't showing up
 *
 */
export const wrapPublicPath = url => {
	if (__SERVER__ && url && url.indexOf(CLIENT_PUBLIC_PATH_FOR_ICONS) < 0) {
		return `${CLIENT_PUBLIC_PATH_FOR_ICONS}${url}`
	}

	return url
}

export default ({ glyph, children, ...props }) => (
	<Icon viewBox={`${glyph.viewBox}`} {...props}>
		<use
			// xlinkHref={__PROD__ ? wrapPublicPath(glyph.url) : `#${glyph.id}`}
			xlinkHref={`#${glyph.id}`}
		/>
	</Icon>
)
